// @ts-nocheck
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import List from 'components/common/List';

import { setVideoIsClicked } from 'actions/clickedVideo';
import {
  addRotatingSegmentTitleId,
  deleteRotatingSegmentTitleId,
} from 'actions/rotatingSegmentTitles';

import Ref from 'models/propTypes/ref';
import Row from 'models/propTypes/row';
import { useIntl } from 'react-intl';

import HomeTile from './HomeTile';

const messages = {
  ttsEndOfNavigation: {
    id: 'navigation.tts.ttsEndOfNavigation',
    description: 'TTS text for navigation command cannot be executed',
  },
};

const HomeRow = ({
  row,
  displayTitle,
  displayScoring,
  games,
  onTileClick,
  rowClassName,
  titleClassName,
  tileClassName,
  forwardedRef,
  focusIdPrefix,
  rowPos,
  onEndOfNavigationOverride,
}) => {
  const dispatch = useDispatch();

  const ttsEndOfNavigation = useIntl().formatMessage(
    messages.ttsEndOfNavigation,
  );

  const rotatingSegmentTitles = useSelector(
    state => state.rotatingSegmentTitles,
  );

  const rotatingSegmentIds = useSelector(
    state => state.updateRotatingSegmentTitles?.rotatingSegmentIds,
  );

  const segmentTitlesEnabled = useSelector(
    state => state.kitchenSink.data?.config?.modules?.SegmentTitles?.enabled,
  );

  const renderItem = (item, index, ref) => {
    let shortTitle = item?.about?.shortTitle;
    if (segmentTitlesEnabled && rotatingSegmentTitles?.data?.titleData) {
      if (
        Object.keys(rotatingSegmentTitles.data.titleData).find(
          key => key === item?.id,
        ) !== undefined
      ) {
        shortTitle =
          rotatingSegmentTitles?.data?.titleData[item?.id].segmentTitle !== null
            ? rotatingSegmentTitles?.data?.titleData[item?.id].segmentTitle
            : shortTitle;
        if (rotatingSegmentIds && rotatingSegmentIds.indexOf(item?.id) === -1) {
          dispatch(addRotatingSegmentTitleId(item?.id));
        }
      } else if (
        rotatingSegmentIds &&
        rotatingSegmentIds.indexOf(item?.id) !== -1
      ) {
        dispatch(deleteRotatingSegmentTitleId(item?.id));
      }
    }
    const updatedItem = { ...item, about: { ...item.about, shortTitle } };

    return (
      <HomeTile
        focusIdPrefix={focusIdPrefix}
        item={updatedItem}
        row={row}
        displayScoring={displayScoring}
        games={games}
        onClick={props => {
          dispatch(
            setVideoIsClicked(updatedItem.id, row.title, rowPos, index + 1),
          );
          onTileClick(props);
        }}
        ref={ref}
        key={updatedItem.id}
        className={tileClassName}
      />
    );
  };

  return (
    <React.Fragment>
      {displayTitle && (
        <div className={classNames(titleClassName, 'font-weight-bold')}>
          {row.title}
        </div>
      )}
      <List
        focusId={row.slug}
        data={row.data}
        buffer={row.layoutType}
        className={rowClassName}
        renderItem={renderItem}
        peekRatio={0}
        restorationId={`${row.slug}`}
        ref={forwardedRef}
        ttsEndOfNavigation={ttsEndOfNavigation}
        onEndOfNavigationOverride={onEndOfNavigationOverride}
      />
    </React.Fragment>
  );
};

HomeRow.propTypes = {
  row: Row.isRequired,
  onTileClick: PropTypes.func,
  rowClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  tileClassName: PropTypes.string,
  displayTitle: PropTypes.bool.isRequired,
  forwardedRef: Ref,
  focusIdPrefix: PropTypes.string,
  displayScoring: PropTypes.bool,
  games: PropTypes.arrayOf(PropTypes.object),
  rowPos: PropTypes.number,
  onEndOfNavigationOverride: PropTypes.func,
};

HomeRow.defaultProps = {
  onTileClick: () => {},
  rowClassName: null,
  titleClassName: null,
  tileClassName: null,
  forwardedRef: null,
  focusIdPrefix: '',
  displayScoring: false,
  games: null,
  rowPos: null,
  onEndOfNavigationOverride: null,
};

export default React.memo(
  React.forwardRef((props, ref) => <HomeRow {...props} forwardedRef={ref} />),
);
